export const apiPrefix = (): string => {
    return "/api/v1"
}

export const build_url = (entity: string): string => {
    return `${apiPrefix()}/${entity}`
}
